import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ElementRef } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
// import { ReportSuccessPopup } from './report-success-popup.html';
// import { DomSanitizer } from '@angular/platform-browser';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { FormsModule } from '@angular/forms';
import { ReportService } from '../shared/';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';


@Component({
  selector: 'app-report-success',
  providers: [ReportService],
  templateUrl: './report-success.component.html',
  styleUrls: ['./report-success.component.scss']
})
export class ReportSuccessComponent implements OnInit {
  overviewModalPopup: ConfirmModalPopupModel;
  modalClass: string;
  ReportPopup: any;
  trustedReportPopup: any;
  showOverviewModal: boolean;
  requestReceived= true;

  @Input()
  modalPopupObject: ConfirmModalPopupModel;
  @Input() triggerElement: any;

  @Output()
  modalOutput: EventEmitter<boolean>;

  focusabbleElements: any;
  report: any;

  constructor(private el: ElementRef,
    private utilityService: UtilityService,
    private reportService: ReportService) {
    this.modalOutput = new EventEmitter<boolean>();
  }

  ngOnInit() {
    this.report = this.reportService.getReportObject();
    this.showOverviewModal = true;

  }

  closeOverviewModal() {
    this.showOverviewModal = false;
  }
  btnAction(value,event?) {

    if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

    this.showOverviewModal = false;
    this.modalOutput.emit(value);
    this.focusabbleElements = undefined;
    if (this.triggerElement) {
      this.triggerElement.focus();
    }
   }
  }

  loadFocustelements() {
    if (!this.focusabbleElements) {
      const focusableEls = this.utilityService.getFocusableElements(this.el);
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      document.getElementById('modalHeading').focus();
    }
  }
  handleError(error) {
    console.log('error');
  }
  dismissInfo() {
    this.requestReceived = false;
  }
}
